export const BASE_API = import.meta.env.VITE_BASE_API || 'https://api.smarttraffic.app/api';
export const LIVE_STATIC_HOST = import.meta.env.VITE_LIVE_STATIC_HOST || 'https://static.smarttraffic.app';

export const LOGO = 'Smart Traffic';

export const SOCKET = {
    host: import.meta.env.VITE_SOCKET_HOST || 'ws://localhost:3222',
};
